import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleRightMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-right-medium, dropdown, caret"><path d="M9 8.89561C9.00054 7.40916 10.7376 6.59967 11.876 7.55576L15.5713 10.6603C16.4034 11.3595 16.4033 12.6406 15.5713 13.3399L11.876 16.4444C10.7375 17.4007 9.00037 16.5912 9 15.1046V8.89561Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTriangleRightMedium;
